import UpdateOMConfig from '@pages/Administrator/OMConfig/ModifyOMConfig/UpdateOMConfig';
import BaseApi from '../BaseApi';
import DeleteOMConfig from '@pages/Administrator/OMConfig/ModifyOMConfig/DeleteOMConfig';

const AdminLogApi = {
  CreateProductCate: (data: any) => {
    return BaseApi.POST('api/Log/Get', data);
  },
  GetAllConfig: () => {
    return BaseApi.GET('api/OMConfig/GetAll')
  },
  GetFeeConfig: () => {
    return BaseApi.GET('api/OMConfig/GetFeeConfig')
  },

  GetConfigWithKey: (key: any) => {
    return BaseApi.GET(`api/OMConfig/GetConfigWithKey?Key=${key}`)
  },

  CreateOMConfig: (data:any) => {
    return BaseApi.POST('api/OMConfig/Create', data);
  },
  UpdateOMConfig: (data: any) => {
    return BaseApi.PUT('api/OMConfig/Update', data)
  },
  DeleteOMConfig: (key: any) => {
    return BaseApi.DELETE(`api/OMConfig/Delete?key=${key}`);
  },
  BackDoor: (data:any) => {
    return BaseApi.POST(`api/Order/BackDoor_ChangeOrderStatusFromCompleteToProcessing?maDonHang=${data}`, {})
  },
  GetListReflect: (beginTime :any, endTime: any) => {
    return BaseApi.POST(`api/Reflect/GetListReflect?beginTime=${beginTime}&endTime=${endTime}`, {})
  },
  GetListReflectDetail: (beginTime :any, endTime: any) => {
    return BaseApi.POST(`api/Reflect/GetListReflectDetail?beginTime=${beginTime}&endTime=${endTime}`, {})
  },
  GetListReflectDetailById: (id: any) => {
    return BaseApi.GET(`api/Reflect/GetReflectDetailById?id=${id}`)
  }
};
export default AdminLogApi;
